import { FaCalendarCheck } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import clsx from "clsx";
import { setIsBookingCartOpen } from "../../redux/features/cartStateBooking";

const FloatingCartButtonBooking = () => {
  const dispatch = useDispatch();
  const bookingCart = useSelector((state) => state?.cartBooking?.bookingCart);
  const isOpen = useSelector((s) => s.cartbooking?.isBookingCartOpen);

  const count = bookingCart?.length || 0;
  const hasItems = count > 0;

  return (
    <div className="fixed bottom-6 right-6 z-[60]">
      {/* Outer gradient halo */}
      <div
        className={clsx(
          "p-[2px] rounded-full transition-transform duration-300",
          hasItems
            ? "bg-gradient-to-br from-red-500 via-red-400 to-red-600"
            : "bg-gradient-to-br from-gray-300 via-gray-400 to-gray-500 dark:from-gray-700 dark:via-gray-600 dark:to-gray-500"
        )}
      >
        {/* Button */}
        <button
          aria-label="Open booking cart"
          onClick={() => dispatch(setIsBookingCartOpen(true))}
          className={clsx(
            "relative flex items-center gap-2 rounded-full px-4 py-3",
            "backdrop-blur-md bg-white/90 dark:bg-neutral-900/80",
            "shadow-lg ring-1 ring-black/5 dark:ring-white/10",
            "transition-all duration-300 hover:translate-y-[-2px] active:translate-y-0",
            "group"
          )}
        >
          {/* Icon */}
          <span
            className={clsx(
              "grid place-items-center rounded-full w-9 h-9",
              "bg-gradient-to-br from-red-500 to-red-600 text-white",
              "shadow-md",
              hasItems && "animate-pulse"
            )}
          >
            <FaCalendarCheck className="text-base" />
          </span>

          {/* Label (desktop hover only) */}
          <span
            className={clsx(
              "hidden sm:block text-sm font-semibold tracking-wide",
              "text-neutral-800 dark:text-neutral-200",
              "max-w-[140px] truncate",
              "transition-all duration-300",
              "group-hover:max-w-[200px]"
            )}
          >
            {hasItems ? "Your booking • Review" : "Empty"}
          </span>

          {/* Count badge */}
          {hasItems && (
            <>
              <span className="absolute -top-1 -right-1 inline-flex items-center justify-center w-5 h-5 text-[10px] font-bold text-white bg-red-500 rounded-full shadow-md animate-bounce">
                {count}
              </span>
              <span className="absolute -top-1 -right-1 inline-flex h-5 w-5">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-40"></span>
              </span>
            </>
          )}
        </button>
      </div>
    </div>
  );
};

export default FloatingCartButtonBooking;
